export default "__VITE_ASSET__ByTrmZzi__"